import { Domain } from '@shared/app/scripts/services/domain';
import { Ga } from '@core/app/scripts/services/ga';
import { HandleData } from '@core/app/scripts/services/handle-data';

export class LoginHandler {
  constructor(
    private $location: ng.ILocationService,
    private $window: ng.IWindowService,
    private domain: Domain,
    private ga: Ga,
    private handleData: HandleData,
    private $translate: ng.translate.ITranslateService,
  ) {}

  /**
   * @ngdoc
   * @name v6CoreModule.loginHandler#redirectToGateway
   * @methodOf v6CoreModule.loginHandler
   * @description
   * redirectets to gateway
   */
  redirectToGateway = (page: string): void => {
    this.$window.location.href = this.domain.link(`www#/${page}`);
  };

  /**
   * @ngdoc
   * @name v6CoreModule.loginHandler#redirectToLogin
   * @methodOf v6CoreModule.loginHandler
   * @description
   * redirectets to gateway
   */
  redirectToLogin = (): void => {
    this.$window.location.href = this.domain.link(
      `login#/login/${encodeURIComponent(this.$location.absUrl())}`,
    );
  };

  /**
   * @ngdoc
   * @name v6CoreModule.loginHandler#init
   * @methodOf v6CoreModule.loginHandler
   *
   * @description
   * Check for existing sid and reuse the session, and try to reuse the session.
   * If failed; checks for domain name, module address parameter & redirects
   * user or leave it on the page.
   */
  init = (settingsPromise, sessionPromise) => {
    const sid = this.handleData.getSID();

    sessionPromise.then(
      (currentSession) => {
        this.ga.set('dimension1', currentSession.username);
      },
      () => {
        this.redirectToLogin();
      },
    );
  };
}

/**
 * @ngdoc service
 * @name v6CoreModule.loginHandler
 * @description
 * Service taking care of logging in & reusing existing session.
 */
angular
  .module('v6CoreModule')
  .factory(
    'loginHandler',
    (
      $location: ng.ILocationService,
      $window: ng.IWindowService,
      domain: Domain,
      ga: Ga,
      handleData: HandleData,
      translate: ng.translate.ITranslateService,
    ) => {
      return new LoginHandler(
        $location,
        $window,
        domain,
        ga,
        handleData,
        translate,
      );
    },
  );
